import { graphql } from 'react-relay';
import type { Media_Catalog_Query_Pagination_Query$variables } from './__generated__/Media_Catalog_Query_Pagination_Query.graphql';
import type { Media_Query_Pagination_Query$variables } from './__generated__/Media_Query_Pagination_Query.graphql';

export * from './__generated__/Media_Query.graphql';
export const MediaQuery = graphql`
  query Media_Query($first: Int, $after: String, $where: RootQueryToMediaItemConnectionWhereArgs) {
    ...Media_Query_Pagination_Fragment
  }
`;

export type Media_Query_Pagination_Fragment$args = Media_Query_Pagination_Query$variables;

export * from './__generated__/Media_Query_Pagination_Fragment.graphql';
export const MediaQueryPaginationFragment = graphql`
  fragment Media_Query_Pagination_Fragment on RootQuery @refetchable(queryName: "Media_Query_Pagination_Query") {
    mediaItems(first: $first, after: $after, where: $where) @connection(key: "MediaComponent_query_mediaItems") {
      __id
      edges {
        node {
          id
          ...Media_Url_Fragment @relay(mask: false)
          mimeType
          title
          fileSize
          author {
            ...Frags_With_Author_Fragment @relay(mask: false)
          }
        }
      }
    }
  }
`;

export type {
  Media_Catalog_Query,
  Media_Catalog_Query$data,
  Media_Catalog_Query$variables,
} from './__generated__/Media_Catalog_Query.graphql';
export const MediaCatalogQuery = graphql`
  query Media_Catalog_Query($first: Int, $after: String, $where: RootQueryToMediaItemConnectionWhereArgs) {
    ...Media_Catalog_Query_Pagination_Fragment
  }
`;

export type Media_Catalog_Query_Pagination_Fragment$args = Media_Catalog_Query_Pagination_Query$variables;

export * from './__generated__/Media_Catalog_Query_Pagination_Fragment.graphql';
export const MediaCatalogQueryPaginationFragment = graphql`
  fragment Media_Catalog_Query_Pagination_Fragment on RootQuery @refetchable(queryName: "Media_Catalog_Query_Pagination_Query") {
    mediaItems(first: $first, after: $after, where: $where) @connection(key: "MediaCatalogComponent_query_mediaItems") {
      __id
      edges {
        node {
          id
          ...Media_Url_Fragment @relay(mask: false)
          mimeType
          status
          title
          fileSize
          date
          author {
            ...Frags_With_Author_Fragment @relay(mask: false)
          }
          catalogCount
        }
      }
    }
  }
`;

export * from './__generated__/Media_Query_By_Query.graphql';
export const MediaQueryByQuery = graphql`
  query Media_Query_By_Query($id: ID!, $idType: MediaItemIdType) {
    mediaItem(id: $id, idType: $idType) {
      ...Media_Url_Fragment @relay(mask: false)
    }
  }
`;
